import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import b from 'b_';
import BrowserStore from '../../browser/stores/BrowserStore';
import FuseButton from '../FuseControls/FuseButton';
import './TroubleshootingModeScreen.css';
import OldTroubleshootingModeScreen from './OldTroubleshootingModeScreen';
import { isFuse5Enabled } from '../../fuseFeatureFlag';

const block = b.lock('NewTroubleshootingModeScreen');

class NewTroubleshootingModeScreen extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired,
    };

    openCustomerSupportModal = () => {
        const { sendFeedbackStore, troubleshootingCaseId } = this.props.browser;

        sendFeedbackStore.openCustomerSupportModal(troubleshootingCaseId);
    };

    render() {
        const { t, browser } = this.props;

        return <div className={block()}>
            <div className={block('TopBar')}>
                <div className={block('RecordIndicator')}>
                    <span className={block('RecordIndicatorIcon')} />
                    {t('troubleshootingMode.recordIndicator')}
                </div>
                <div className={block('Title')}>
                    <span>{t('troubleshootingMode.title')}</span>
                </div>
                <div className={block('Buttons')}>
                    <FuseButton
                        type="primary"
                        icon="info_outline"
                        onClick={browser.troubleshootingInstructionsModal.toggle}
                        className={block('InstructionsButton')}
                    >
                        Instructions
                    </FuseButton>
                    <FuseButton
                        type="primary"
                        icon="stop_circle"
                        onClick={this.openCustomerSupportModal}
                        className={block('RecordButton')}
                    >
                        {t('troubleshootingMode.recordButton')}
                    </FuseButton>
                </div>
            </div>
            <div className={block('ContentWrapper')}>
                {this.props.children}
            </div>
        </div>;
    }
}


const WrappedNewTroubleshootingModeScreen = translate()(inject('browser')(observer(NewTroubleshootingModeScreen)));

const TroubleshootingModeScreen = (props) => {
    return isFuse5Enabled()
        ? <WrappedNewTroubleshootingModeScreen {...props} />
        : <OldTroubleshootingModeScreen {...props} />;
};

export default TroubleshootingModeScreen;
